import { useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { PageContent, PageHeader } from '@/components/layout/PageLayout';
import DocumentUpload from '@/components/documents/DocumentUpload';
import CloudImportButtons from '@/components/documents/CloudImportButtons';
import ImportProgress from '@/components/documents/ImportProgress';
import ErrorBoundary from '@/components/common/ErrorBoundary';

export default function UploadPage() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [activeImportJobIds, setActiveImportJobIds] = useState<string[]>([]);

  const handleImportStarted = useCallback((importJobId: string) => {
    setActiveImportJobIds((prev) => [...prev, importJobId]);
  }, []);

  const handleUploadComplete = useCallback(() => {
    navigate('/documents');
  }, [navigate]);

  return (
    <PageContent>
      <PageHeader
        title={t('upload.title')}
        subtitle={t('upload.subtitle')}
        actions={
          <Button variant="outline-secondary" onClick={() => navigate('/documents')}>
            {t('upload.viewDocuments')}
          </Button>
        }
      />
      <ErrorBoundary>
        <DocumentUpload onUploadComplete={handleUploadComplete} />
        <CloudImportButtons onImportStarted={handleImportStarted} />
        {activeImportJobIds.map((id) => (
          <ImportProgress key={id} importJobId={id} />
        ))}
      </ErrorBoundary>
    </PageContent>
  );
}
